module.exports = __webpack_public_path__ + "static/media/imge-10.43405785.jpg";